import { render } from "./zt-full-layout.vue?vue&type=template&id=3f8d03af"
import script from "./zt-full-layout.vue?vue&type=script&lang=js"
export * from "./zt-full-layout.vue?vue&type=script&lang=js"

import "./zt-full-layout.vue?vue&type=style&index=0&id=3f8d03af&lang=scss"

import exportComponent from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/updsh/risk-manager-ui/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__